module.exports = __webpack_public_path__ + "static/media/icon-money-3.06bc965c.svg";